<template>
  <div class="container">
    <inactivity-detection
      :secondsToTrigger="15 * 60"
      :onTrigger="bypassNavigationCheck"
      type="refresh"
      modalId="refreshModal"
      >{{
        TEXTS.render(`BOOKING_FORM_DETAILS_INACTIVITY`)
      }}</inactivity-detection
    >
    <AlertModal
      ref="alertModal"
      modalId="wasteStreamAlertModal"></AlertModal>
    <ConfirmationModalRetry modalId="pageModalRetry" />
    <ErrorModal modalId="errorModal" />
    <ConfirmationModal modalId="pageCloseModal" triggerEventName="waitDontGo" />
    <ConfirmationModal
      modalId="freeEntitlementCount"
      triggerEventName="showFreeEntitlements"
    />
    <ConfirmationModal
      modalId="confirmClearingServiceGroup"
      triggerEventName="confirmClearingServiceGroup"
    />
    <AlertModal ref="alertModal" />
    <PaymentResultModal
      modalId="paymetResult"
      triggerEventName="showPaymentResult"
    />
    <div class="booking-form-loading-container d-flex justify-content-center">
      <loader-circle :classes="fetchLoadingClasses" />
    </div>
    <div
      class="row justify-content-center"
      :class="portalName"
      v-show="fetchLoadingClasses.indexOf('loading-circle--show') === -1"
    >
      <div class="col-lg-12">
        <div class="card">
          <step-form />
          <hr />
          <!-- Step 1 -->
          <div class="pt-2 pl-3 pr-3 pb-4" v-show="getIndexStep === 0">
            <select-service-button
              :availableEntitledDatesLength="availableEntitledDatesLength"
              v-on:nextsection="focusOnSectionAfter('selectServiceButton')"
              v-on:showAlert="serviceAlert"
              :easySwitch="easySwitchToServiceGroup"
              v-on:setEasySwitch="addNewProductService"
              v-on:showConfirm="serviceGroupConfirm"
              v-on:showConfirmClearGroup="showConfirmClearGroup"
            />
            <div id="additionalQuestion"></div>
            <additional-questions />
            <div id="termsAndConditionsAnchor"></div>
            <terms-and-condition
              v-on:nextsection="focusOnSectionAfter('termsAndConditions')"
            />
            <div v-show="displayServices">
              <div id="entitlementTableAnchor"></div>
              <EntitlementTable ref="entitlementTable"/>

              <BinCollectionScheduleCompact
                v-if="displayBinCollectionSchedule"
              />

              <div id="selectPaymentAnchor"></div>
              <select-payment-button
                :availableEntitledDatesLength="availableEntitledDatesLength"
                v-on:removeLoader="removeLoader()"
                v-on:nextsection="focusOnSectionAfter('selectPaymentButton')"
                v-on:showAlert="serviceAlert"
                v-on:showConfirmClearGroup="showConfirmClearGroup"
              />
            </div>
            <div id="wasteAnchor"></div>
            <div class="pl-3 pr-3" v-show="displayWasteOptions">
              <div class="position-relative row">
                <div class="col-12 col-lg-6">
                  <ProductSelection
                    :selectedService="selectedService"
                    class="w-100"
                    ref="productSelection"
                    @priceSettingsLoaded="
                      (result) => {
                        priceSettings = result;
                      }
                    "
                  />
                  <collection-week
                    ref="collectionWeek"
                    @setMultipleCollection="setMultipleCollection"
                     v-on:showAlert="serviceAlert"
                  />
                </div>
                <div class="col-12 col-lg-6">
                  <booking-summary
                    :allPrices="priceSettings"
                    @showConfirmClearGroup="showConfirmClearGroup"
                    @removeProductFromSummary="
                      (wastes) => {
                        $refs.productSelection.pluckProductFromSelection(
                          wastes
                        );
                      }
                    "
                    ref="bookingSummary"
                  />
                </div>
              </div>
              <div class="row">
                <comment ref="comment" />
              </div>
            </div>
          </div>

          <!-- Step 2 -->
          <div class="pt-2" v-if="getIndexStep === 1">
            <!-- <personal-info :in-booking="true" /> -->
            <personal-info ref="personalInfo" :in-booking="true" :hideNames="true"/>
          </div>

          <!-- Step 3 -->
          <div class="pt-2 pl-3 pr-3 mb-4" v-show="getIndexStep === 2">
            <payment-section ref="paymentSection" :hasPaidMultiServiceProducts="HAS_PAID_PRODUCTS" />
          </div>

          <!-- Step 4 / Last Step -->
          <div class="pt-2" v-show="getIndexStep === 3">
            <booking-completed-thank-you />
            <hr class="d-none d-md-block" />
            <booking-completed
              :hasPaidMultiServiceProducts="HAS_PAID_PRODUCTS"
            />
          </div>
          <div
            class="pl-3 pr-3 pb-4"
            v-if="this.bookingState.isAgreedToTerms === 'yes'"
          >
            <!-- Footer buttons -->
            <div class="container pb-lg-4">
              <div class="row no-gutters justify-content-end">
                <div
                  class="col-12 col-lg-3 mr-lg-2"
                  v-if="getIndexStep >= 1 && getIndexStep <= 2"
                >
                  <ColoredButtonInverted @click="prevBtn" class="mb-2">{{
                    TEXTS.render(`BOOKING_FORM_BTN_BACK`)
                  }}</ColoredButtonInverted>
                </div>
                <div
                  class="col-12 col-lg-3 mr-lg-2"
                  v-if="
                    getIndexStep === 0 &&
                    isServiceSelected &&
                    $store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED
                  "
                >
                  <ColoredButtonInverted @click="addNewProductService(true)" class="mb-2">{{
                    TEXTS.render(
                      `MULTIPLE_SERVICE_SERVICE_GROUP_BOOKING_ADD_NEW`
                    )
                  }}</ColoredButtonInverted>
                </div>
                <div
                  class="col-12 col-lg-3"
                  v-if="
                    getIndexStep <= 1 &&
                    getIndexStep + 1 !== $store.state.totalSteps &&
                    isServiceSelected
                  "
                >
                  <ColoredButton @click="nextBtn" class="mb-2">{{
                    TEXTS.render(`BOOKING_FORM_BTN_NEXT`)
                  }}</ColoredButton>
                </div>
                <div
                  class="col-12 col-lg-3"
                  v-if="
                    getIndexStep >= 1 &&
                    getIndexStep + 1 == $store.state.totalSteps &&
                    $store.state.totalSteps < 3
                  "
                >
                  <ColoredButton @click="nextBtn" class="mb-2">{{
                    TEXTS.render(`BOOKING_FORM_BTN_SUBMIT`)
                  }}</ColoredButton>
                </div>
                <div class="col-12 col-lg-3" v-if="getIndexStep === 2">
                  <ColoredButton @click="nextBtn" class="mb-2">{{
                    TEXTS.render(`BOOKING_FORM_BTN_PAY_NOW`)
                  }}</ColoredButton>
                </div>

                <div class="col-12 col-lg-3" v-if="getIndexStep === 3">
                  <!-- Available only during confirmed booking -->
                  <ColoredButtonInverted
                    @click="backToHome"
                    >{{
                      TEXTS.render(`BOOKING_FORM_BTN_TO_HOME`)
                    }}</ColoredButtonInverted
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InactivityDetection from "../../../../common/components/InactivityDetection";
import AlertModal from "../../../../common/components/AlertModal";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import ConfirmationModalRetry from "../../../../common/components/ConfirmationModalRetry";
import ErrorModal from "../../../../common/components/ErrorModal";
import PaymentResultModal from "../../../../common/components/PaymentResultModal";
import StepForm from "./StepForm";
import SelectServiceButton from "./SelectServiceButton";
import SelectPaymentButton from "./SelectPaymentButton";
import EntitlementTable from "./EntitlementTable";
import BinCollectionScheduleCompact from "./BinCollectionScheduleCompact";
import MultipleCollection from "./MultipleCollection";
import BookingSummary from "./BookingSummary";
import CollectionWeek from "./CollectionWeek";
import Comment from "./Comment";
import PersonalInfo from "../../profile/components/PersonalInfo";
import BookingCompletedThankYou from "./BookingCompletedThankYou";
import BookingCompleted from "./BookingCompleted";
import PaymentSection from "./PaymentSection";
import TermsAndCondition from "./TermsandCondition";
import ColoredButton from "../../../../common/components/ColoredButton";
import ColoredButtonInverted from "../../../../common/components/ColoredButtonInverted";
import BookingStateManager from "../../../../common/utils/BookingStateManager";
import SelectedWasteSummary from "../../../../common/utils/SelectedWasteSummary";
import Helper from "../../../../helper";
import LoaderCircle from "../../../../common/components/LoaderCircle";
import Texts from "../../../../common/utils/Texts";
import ProductSelection from "./ProductSelection";
import ServicePrices from "../../../../common/utils/ServicePrices";
import MultipleServiceSelectedBooking from "../../../../common/utils/MultipleServiceSelectedBooking";
import ServerDateMixin from "../../../../common/mixins/ServerDateMixin";
import BookingAddressMixin from "../../../../common/mixins/BookingAddressMixin";
import DateNoTz from "../../../../common/utils/DateNoTz";
import AdditionalQuestions from "./AdditionalQuestions";

export default {
  mixins: [ServerDateMixin, BookingAddressMixin],
  components: {
    InactivityDetection,
    AlertModal,
    ConfirmationModal,
    ConfirmationModal,
    ConfirmationModalRetry,
    PaymentResultModal,
    ErrorModal,
    StepForm,
    SelectServiceButton,
    SelectPaymentButton,
    EntitlementTable,
    BinCollectionScheduleCompact,
    MultipleCollection,
    BookingSummary,
    CollectionWeek,
    Comment,
    PersonalInfo,
    BookingCompletedThankYou,
    BookingCompleted,
    PaymentSection,
    TermsAndCondition,
    ColoredButton,
    ColoredButtonInverted,
    LoaderCircle,
    ProductSelection,
    AdditionalQuestions,
  },
  data() {
    return {
      optionSelected: "",
      stepsform: "",
      activeStepIndex: "",
      allowNext: true,
      allowNavigation: false,
      fetchLoadingClasses: ["fetch-favorite-loading", "loading-circle--show"],
      easySwitchToServiceGroup: false,
      multipleServiceSelectedBooking: null,
      availableEntitledDatesLength: 0,
      priceSettings: null,
      portalName: Helper.getPortalName(),
    };
  },
  computed: {
    TEXTS: () => Texts,
    bookingState: function () {
      return this.$store.getters.GET_BOOKING_STATE;
    },
    bookingSubmission: function () {
      return this.$store.getters.GET_BOOKING_SUBMISSION;
    },

    cartErrors: function () {
      if (!this.bookingState || !this.bookingState.selectedService) {
        return "Please select a service";
      } else if (
        this.bookingState.selectedService.is_paid == Helper.Payment.Free
      ) {
        return null;
      } else if (
        this.bookingState.selectedService.is_paid == Helper.Payment.Paid
      ) {
        var bookingSummaryDetails = this.$store.getters
          .GET_BOOKING_SUMMARY_DETAILS;
        var totalAmount = parseFloat(bookingSummaryDetails.totalAmount);
        if (totalAmount <= 0) {
          return Texts.render(`BOOKING_FORM_DETAILS_VALIDATION_NO_CART`);
        }
      } else {
        return null;
      }
    },
    paymentInfo: function () {
      return this.$store.getters.GET_PAYMENT_INFO;
    },
    displayServices: function () {
      return (
        this.bookingState &&
        (this.bookingState.isAgreedToTerms == "yes" ||
          this.bookingState.isAgreedToTerms == true)
      );
    },
    displayWasteOptions: function () {
      return this.displayServices && this.isServiceSelected;
    },
    getIndexStep() {
      return this.$store.getters.GET_ACTIVEFORM_INDEX;
    },
    formSubmitted() {
      return this.$store.getters.GET_BOOKING_SUBMISSION.submitted;
    },
    isServiceSelected() {
      var selectedService = this.$store.getters.GET_BOOKING_STATE
        .selectedService;
      return (selectedService && selectedService.service_setting_id) != null;
    },
    selectedService() {
      return this.$store.getters.GET_BOOKING_STATE.selectedService;
    },
    MainUISettings() {
      return this.$store.getters["GET_MAIN_UI"];
    },
    productHasOtherSelected() {
      const isMultiple = this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED;
      const products = !isMultiple
        ? this.bookingState.selectedBookingProducts
        : this.$store.getters
            .GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS;
      const has = products.some((productInfo) => {
        // --- Looking for Products that have "others in the display name"
        var displayName = null;
        if (!isMultiple) {
          displayName = productInfo.productNames.displayName || null;
        } else {
          displayName = productInfo.name.displayName || null;
        }

        return displayName && displayName.toLowerCase().indexOf("other") > -1;
      });
      return has;
    },
    activeAddress: function () {
      return this.$store.getters.GET_BOOKING_STATE.activeAddress;
    },
    activeAddressSetting: function () {
      var addressSettingList = this.$store.getters.GET_SERVICE_GROUP_ADDRESS
        .list;

      if (!addressSettingList || !this.activeAddress) {
        return;
      }

      var activeAddressSetting = addressSettingList.find((addressSetting) => {
        return (
          addressSetting.website_action == this.activeAddress.websiteAction
        );
      });

      return activeAddressSetting;
    },
    // Waste Streams that will be submitted automatically
    defaultWasteStreams() {
      var defaultWasteStreams = [];

      if (!this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) {
        // Pull the settings from the Service
        if (
          this.selectedService &&
          Array.isArray(this.selectedService.submit_with_waste_stream)
        ) {
          const flattenIdArray = this.selectedService.submit_with_waste_stream.map(
            (wasteStream) => wasteStream.waste_stream_setting_id
          );
          const wasteStreamList =
            this.$store.getters.GET_VIEW_WASTE_STREAMS.list || [];
          defaultWasteStreams = wasteStreamList.filter((wasteStream) =>
            flattenIdArray.includes(wasteStream.waste_stream_setting_id)
          );
        }
      } else {
        /************Multiple Service-Service Group Booking Enabled************/
        const productGroupByService = this.multipleServiceProductsGroupBy(
          "service_setting_id"
        );

        const uniqueWasteStreamSettingIds = new Set();
        this.$store.getters.GET_SERVICES.list.forEach((service) => {
          if (Array.isArray(service.submit_with_waste_stream)) {
            service.submit_with_waste_stream.forEach((waste) => {
              uniqueWasteStreamSettingIds.add(waste.waste_stream_setting_id);
            });
          }
        });

        for (var e = 0; e < productGroupByService.length; e++) {
          const [service_setting_id, products] = productGroupByService[e];

          defaultWasteStreams = [
            ...defaultWasteStreams,
            ...products.filter((wasteStream) =>
              uniqueWasteStreamSettingIds.has(
                wasteStream.waste_stream_setting_id
              )
            ),
          ];
        }
      }

      return defaultWasteStreams;
    },
    GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED() {
      return this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED;
    },
    HAS_PAID_PRODUCTS() {
      return this.multipleServiceSelectedBooking
        ? this.multipleServiceSelectedBooking.hasPaidProducts(
            this.$store.getters
              .GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS
          )
        : false;
    },
    userType() {
      return this.$store.getters.GET_PERSONAL_INFO.type;
    },
    isWasteStreamFrom1Coast() {
      const { selection, submission, per_waste_collection } =
        this.$store.getters.GET_ACTIVE_MULTIPLE_COLLECTION_SETTING || {};
      return selection == 2 && submission == 1 && per_waste_collection == 1;
    },
    displayBinCollectionSchedule() {
      var selectedServiceGroup = this.bookingState.selectedServiceGroup;
      return selectedServiceGroup
        ? selectedServiceGroup.display_bin_sizes == 1
        : false;
    },
  },
  beforeRouteLeave(to, from, next) {
    var self = this;
    if (
      !self.allowNavigation &&
      self.bookingState &&
      self.bookingState.selectedServiceGroup &&
      self.getIndexStep !== 3
    ) {
      this.$emit(
        "waitDontGo",
        Texts.render(`BOOKING_FORM_DETAILS_WAIT_DONT_GO`),
        async function () {
          // Remove active address before reset booking state
          if (self.activeAddress && self.activeAddress.displayName) {
            self.removeAddressToList(self.activeAddress.displayName.toLowerCase());
          }

          self.$store.dispatch("resetBookingState");
          self.$store.dispatch("resetAvailableBookingDatesOfAddress");
            
          setTimeout(next, 500); // Delaying to give time for modal to close
        }
      );
    } else {
      // Remove active address before reset booking state
      if (self.activeAddress && self.activeAddress.displayName) {
        self.removeAddressToList(self.activeAddress.displayName.toLowerCase());
      }
      
      self.$store.dispatch("resetAvailableBookingDatesOfAddress");
      next();
    }
  },
  beforeMount() {
    if (this.getIndexStep !== 3)
      window.addEventListener("beforeunload", this.checkBeforeReload);
  },
  beforeDestroy() {
    if(this.activeAddress && this.activeAddress.displayName) {
      this.removeAddressToList(this.activeAddress.displayName.toLowerCase());
    }

    if (this.getIndexStep !== 3)
      window.removeEventListener("beforeunload", this.checkBeforeReload);
      this.$store.dispatch("resetBookingState");
  },
  mounted() {
    $('#pageLoadingModal').modal('hide');
    this.forceMounted();
    // --- Reset Form
    var self = this;

    this.$parent.$on("resetBookingForm", function () {
      if (self.$refs.comment) {
        self.$refs.comment.resetForm();
        self.$refs.entitlementTable.resetForm();
        self.$refs.paymentSection.resetForm();
      }
    });
  },
  methods: {
    qtyCapExceeds() {
      const parentwastes = Helper.objectsGroupBy(this.$refs.productSelection.$refs.wasteStreamSelection.wasteStreams, 'waste_stream_setting_id');
      
      let error = null;
      for (const waste_stream_setting_id in parentwastes) {
        if (error) {
          continue;
        }
        const wasteSum = this.bookingState.selectedBookingProducts
                            .filter(
                              w =>
                                w.waste_stream_setting_id == waste_stream_setting_id)
                            .reduce(
                              (currSum, product) =>
                                (product && product.qty) + currSum, 0);
        const wasteStreamQty = ( parentwastes[waste_stream_setting_id].length > 0 &&
                      parentwastes[waste_stream_setting_id][0] &&
                      parentwastes[waste_stream_setting_id][0].qty_cap &&
                      Number(parentwastes[waste_stream_setting_id][0].qty_cap) ) || 0;
        if (wasteStreamQty && wasteSum > wasteStreamQty) {
          const wasteStreamName = ( parentwastes[waste_stream_setting_id].length > 0 &&
                                      parentwastes[waste_stream_setting_id][0] &&
                                      parentwastes[waste_stream_setting_id][0].waste_stream_name );
          error = Texts.render('ERROR_EXCEEDED_BOOKING_QTY_CAP', null, { wasteStreamQty, wasteStreamName })
        }
      }
      return error;
    },
    forceMounted() {
      this.$store.dispatch("getAddressSetting");
      this.$store.dispatch("resetBookingState");
      this.$store.dispatch("resetAvailableBookingDatesOfAddress");

      var stateManager = new BookingStateManager();
      var bookingState = stateManager.loadBookingStateFromUrl(
        window.location.href
      );

      // --- Scroll To Top
      window.scrollTo(0, 0);

      if (!bookingState) {
        this.$router.push("home");
      } else {
        this.$store.dispatch("setBookingState", bookingState);
        let retryApiTime = localStorage.retryApiTimeAvailableBookingDates || 0;
        let remainingTime = retryApiTime - (+ new Date());

        this.$store.dispatch(
          "getAvailableBookingDatesOfAddress",
          bookingState.activeAddress.id
        );
        this.$store.dispatch("getDefaultData");
        this.activeStepIndex = this.getIndexStep;
      }

      this.addNewProductService(false);

      this.multipleServiceSelectedBooking = new MultipleServiceSelectedBooking();
    },
    forceMountedData() {
      const initialData = {
        optionSelected: "",
        stepsform: "",
        activeStepIndex: "",
        allowNext: true,
        allowNavigation: false,
        fetchLoadingClasses: ["fetch-favorite-loading", "loading-circle--show"],
        easySwitchToServiceGroup: false,
        multipleServiceSelectedBooking: null,
        availableEntitledDatesLength: 0,
        priceSettings: null,
      };

      for (let p in initialData) {
        this[p] = initialData[p];
      }
    },
    forceMountedResetCalendar() {
      this.$refs.collectionWeek.$refs.residentDatePicker.reset();
    },
    multipleServiceProductsGroupBy(field) {
      return Object.entries(
        Helper.objectsGroupBy(
          this.$store.getters
            .GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS,
          field
        )
      );
    },
    generateWorkOrderBody() {
      // --- Get the collection data
      const collectionData = this.bookingState.collectionData || {};
      const selectedPeriod = collectionData.selectedPeriod; // --- Fix this

      // --- Format the completion date
      let extractCollectionDate = (chosenDate) => {
        if (typeof chosenDate === "object") {
          let localCompletionDateValue = null;
          if (chosenDate.end) {
            localCompletionDateValue = {
              from:
                chosenDate.start.getFullYear() +
                  "-" +
                  ("0" + (chosenDate.start.getMonth() + 1)).slice(-2) +
                  "-" +
                  ("0" + chosenDate.start.getDate()).slice(-2) || "",
              to:
                chosenDate.end.getFullYear() +
                  "-" +
                  ("0" + (chosenDate.end.getMonth() + 1)).slice(-2) +
                  "-" +
                  ("0" + chosenDate.end.getDate()).slice(-2) || "",
            };
            // completionDate = chosenDate.end;
          } else {
            localCompletionDateValue = {
              to: chosenDate,
            };
          }
          return localCompletionDateValue;
        }
        return {};
      };

      let getMultipleCollectionCount = (service_setting_id) => {
        const service_group_id = this.$store.getters.GET_SERVICES.list.find(
          (servce) => servce.service_setting_id == service_setting_id
        );
        const record = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_OTHER_BOOKING_STATE.find(
          (record) =>
            record.service_group_id === service_group_id.service_group_id &&
            record.service_setting_id == service_setting_id
        );
        return record ? record.multipleCollectionCount || 1 : 1;
      };

      let getComputedEntitlement = (service_setting_id) => {
        const service_group_id = this.$store.getters.GET_SERVICES.list.find(
          (servce) => servce.service_setting_id == service_setting_id
        );
        const record = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_OTHER_BOOKING_STATE.find(
          (record) =>
            record.service_group_id === service_group_id.service_group_id &&
            record.service_setting_id == service_setting_id
        );
        return record ? record.computedEntitlement || 0 : 0;
      };

      let dateRequested = new DateNoTz(this.getServerDate()).asJsDate();

      // --- Booking Products
      var selectedBookingProducts = (!this
        .GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED
        ? this.bookingState.selectedBookingProducts
        : this.$store.getters
            .GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS
      ).map((bookingProduct) => bookingProduct);

      // --- P2HC01: purging fake bookingproducts
      if (Array.isArray(selectedBookingProducts)) {
        // --- Attach the fake stream to its parent stream
        var fakeStreams = selectedBookingProducts.filter((product) => {
          return product.isFake ||
            (typeof product.option_id == "string" &&
              product.option_id.indexOf("fake") > -1)
        });
        // --- For Each Fake Stream, find it's depdent's name and assign it to it
        // --- WARNING: This is being done MANUALLY because of lack of time and inability to properly assign data to multiple service states
        // It would be better if you could assign the dependency data in the cart and then just pull from there 

        /*
          Remove all old code from previous devs. 
          Adding the way to setup more portal.
        */
        var currentportal = Helper.getPortalName();
        var fakeMap = [];
        if(currentportal == "1coast"){
          fakeMap = {
            fridge : "general household"
          }
        }else{
          fakeMap = {
            fridge : "general household"
          }
        }
        fakeStreams.forEach(fakeStream => {
          var parentName = fakeMap[fakeStream.apiValue];
          /*var parentOfFake = selectedBookingProducts.find(product => {
            var productName = typeof product.name == "string" ? product.name : null
            productName = !productName && typeof product.name == "object" ? product.name.displayName : null
            productName = typeof productName == "string" ? productName.toLowerCase() : null
            return productName == parentName
          })*/

          selectedBookingProducts.forEach((slbookingpro) => {
            //var productNames = slbookingpro.productNames;
            //var displayName = productNames.displayName.toLowerCase();

            const isMultiple = this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED;
            var displayName = null;
            if (!isMultiple) {
              displayName = slbookingpro.productNames.displayName.toLowerCase() || null;
            } else {
              displayName = slbookingpro.name.displayName.toLowerCase() || null;
            }
            if(displayName == parentName){
              slbookingpro.fakeStream = fakeStream.apiValue; 
              return;
            }
          });

          /*if(parentOfFake){
            parentOfFake.fakeStream = fakeStream.apiValue 
          } 
          //console.log(parentOfFake);*/
        })

        // --- Purge all the fake Streams
        selectedBookingProducts = selectedBookingProducts.filter((product) => {
          if (
            product.isFake ||
            (typeof product.option_id == "string" && 
              product.option_id.indexOf("fake") > -1)
          ) {
            return false;
          } else {
            return true;
          }
        });

      } //end something?

      // --- Add Default Waste Streams if they don't already exist
      if (this.defaultWasteStreams) {
        this.defaultWasteStreams.forEach((wasteStream) => {
          var foundWasteStream = selectedBookingProducts.find(
            (selectedWasteStream) =>
              selectedWasteStream.waste_stream_setting_id ===
              wasteStream.waste_stream_setting_id
          );
          if (!foundWasteStream)
            selectedBookingProducts.push({
              apiValue: wasteStream.apiValue,
              max_per_collection: wasteStream.max_per_collection,
              price: 100,
              qty: 0,
              uom: wasteStream.uom,
              waste_stream_setting_id: wasteStream.waste_stream_setting_id,
              waste_stream_name: wasteStream.waste_stream_name,
              waste_variation_id: wasteStream.waste_variation_id,
              woi_item_type_id: wasteStream.waste_woi_item_type_id,
              submit_by_default: true,
            });
        });
      }

      // --- Order Selected Booking Products According to WasteStreamId
      // selectedBookingProducts.sort((itemA, itemB) => {
      //     // --- Push Services to the top
      //     if (itemA.isService) {
      //         return -1
      //     }
      //     else if(itemB.isService){
      //         return 1
      //     }

      //     // --- Sort by Waste Stream Id
      //     else if(!itemA.waste_stream_setting_id || !itemB.waste_stream_setting_id){
      //         return itemA.waste_stream_setting_id ? -1 : 1
      //     }
      //     else if(itemA.waste_stream_setting_id !== itemB.waste_stream_setting_id){
      //         return itemA.waste_stream_setting_id - itemB.waste_stream_setting_id
      //     }
      //     // --- Sort further by waste variation id

      //     else if(itemA.waste_stream_setting_id === itemB.waste_stream_setting_id){
      //         return itemA.option_id < itemB.option_id
      //     }
      // });

      // --- Address Details
      const bookingState = this.bookingState || {};
      var address = bookingState.activeAddress;

      // --- Customer Information
      const personalInfo = bookingState.personalInfo || {};
      var customerId = this.bookingState.activeAddress.id,
        firstName = personalInfo.firstName,
        lastName = personalInfo.lastName || "",
        phoneNumber = personalInfo.phone,
        emailAddress = personalInfo.email,
        receivingAgent = bookingState.receivingAgent || "",
        userComment = bookingState.comment || "";

      // Add additional question to WoComments
      if(bookingState.additionalQuestion && bookingState.additionalQuestion != "") {
        userComment = userComment.trim() + " " + bookingState.additionalQuestion;
      }

      // --- Cost
      var summaryDetails = bookingState.summaryDetails || {};
      var isFree = !this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED
          ? this.bookingState.selectedService.is_paid === Helper.Payment.Free
          : !this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS.some(
              (product) => product.isPaid
            ),
        gst = summaryDetails.gstComputed,
        subTotal = summaryDetails.subTotal;

      // --- Construct Work Order Body
      const uId = Helper.generateUuid().toUpperCase();

      var workOrderObj = {
        crn: `REF-${uId}`,
        bpoint: null,
        address,
        customerId,
        firstName,
        lastName,
        phoneNumber,
        emailAddress,
        receivingAgent,
        userComment: userComment.trim(),
        dateRequested,
        isFree,
        gst,
        subTotal,
        PreparationDate: collectionData.PreparationDate
      };

      let servicePricesObject = null;
      let serviceSettingsObject = null;

      if (this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) {
        const servicePrices = new ServicePrices();
        servicePricesObject = Helper.objectsGroupBy(
          servicePrices.allServices,
          "service_setting_id"
        );
      }

      serviceSettingsObject = Helper.objectsGroupBy(
        this.$store.getters.GET_SERVICES.list,
        "service_setting_id"
      );

      // --- TODO: Refactor this for multiple service selection
      // --- Service Information for SINGLE service orders
      const self = this;
      const arrServices = [];
      const selectedServices = !this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED
        ? [[this.selectedService.service_setting_id, selectedBookingProducts]]
        : this.multipleServiceProductsGroupBy("service_setting_id");

      selectedServices.forEach((servicePart) => {
        const [service_setting_id, selectedBookingProducts] = servicePart;
        var service = service_setting_id,
          serviceId = service_setting_id,
          multipleCollectionCount = !self.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED
            ? bookingState.multipleCollectionCount
            : getMultipleCollectionCount(service_setting_id),
          collectionDate = !self.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED
            ? extractCollectionDate(selectedPeriod)
            : extractCollectionDate(
                this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_DATES.find(
                  (schedule) =>
                    schedule.service_setting_id == service_setting_id
                ).selectedPeriod || new DateNoTz(this.getServerDate())
              ),
          computedEntitlement = !self.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED
            ? bookingState.computedEntitlement || 0
            : getComputedEntitlement(service_setting_id),
          serviceComment = workOrderObj.userComment || '';
          
          if(self.bookingState && self.bookingState.commentMap) {
            serviceComment = self.bookingState.commentMap[service_setting_id] || ''
            // Add additional question to WoComments
            if(bookingState.additionalQuestion && bookingState.additionalQuestion != "") {
              serviceComment = serviceComment.trim() + " " + bookingState.additionalQuestion;
            }
          }
            
        var service = {
          service,
          serviceId,
          multipleCollectionCount,
          collectionDate,
          computedEntitlement,
          cost: 0, // --- Requested to be 0 by default by Shan
          wasteStreams: [],
          PickupDate: !self.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED
            ? this.bookingState.collectionData.pickupDate || ""
            : this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_DATES.find(
                (schedule) => schedule.service_setting_id == service_setting_id
              ).pickupDate || "",
          serviceComment: typeof serviceComment === 'string' ? serviceComment.trim() : '',
        };

        if (!self.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) {
          workOrderObj.PickupDate = service.PickupDate;
          workOrderObj.PreparationNote = this.$refs.collectionWeek.preparationNote;
          if(this.$refs.collectionWeek.preparationDate)
            workOrderObj.PreparationDate = this.$refs.collectionWeek.preparationDate.formatFullDayDdMonYyyy();
        }

        // workOrderObj.collectionDate = collectionDate // FIXME Let me know if i'm needed!

        if (self.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) {
          service.name =
            serviceSettingsObject[service_setting_id][0].service_name;
          service.cost =
            servicePricesObject && servicePricesObject[service_setting_id]
              ? servicePricesObject[service_setting_id][0].price
              : 0;
          service.qty = 1; // Fixed to single quantity for service price
          service.isFree = !selectedBookingProducts.some((p) => p.isPaid);
        }
        selectedBookingProducts.forEach((selectedProduct) => {
          // --- Detect Services
          if (selectedProduct.isService == true) {
            // For Multiple Service Booking, this IF block may not happen at all.
            service.name = selectedProduct.name;
            service.cost = selectedProduct.price;
            service.qty = selectedProduct.qty;
            service.isFree = isFree;
          } else {
            // --- Get Waste Stream Details
            var wasteStreamId = selectedProduct.waste_stream_setting_id,
              wasteVariationId = selectedProduct.waste_variation_id,
              woiWasteTypeId = !self.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED
                ? selectedProduct.waste_woi_waste_type_id
                : selectedProduct.woi_waste_type_id,
              woiWasteItemTypeId = !self.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED
                ? selectedProduct.waste_woi_item_type_id
                : selectedProduct.woi_item_type_id,
              wasteComboId,
              name = !this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED
                ? selectedProduct.productNames
                : selectedProduct.name,
              fakeStream = selectedProduct.fakeStream
            // --- Status Booleans
            var isWasteStream =
                wasteStreamId &&
                !wasteVariationId &&
                !woiWasteTypeId &&
                !woiWasteItemTypeId &&
                !wasteComboId,
              isWasteVariation = wasteVariationId != null,
              isWoiWasteType = woiWasteTypeId != null,
              isWoiWasteItemType = woiWasteItemTypeId != null,
              isSubmitWith = selectedProduct.isSubmitWith || false,
              isSubmitDefault = selectedProduct.submit_by_default || false;
            // -- Get Booking Details
            var qty = selectedProduct.qty,
              cost = selectedProduct.price;

            // --- Check if Fake
            var isFake =
              selectedProduct.isFake ||
              (typeof selectedProduct.option_id == "string" &&
                selectedProduct.option_id.indexOf("fake") > -1);
            // --- 1Coast Specific Values
            var wasteStreamComputedEntitlement;
            var serviceSettingOfWasteStream = serviceSettingsObject
              ? serviceSettingsObject[selectedProduct.service_setting_id]
              : [{}];
            if (
              this.isWasteStreamFrom1Coast &&
              serviceSettingOfWasteStream[0].separate_booking_per_waste == 1
            ) {
              wasteStreamComputedEntitlement = -1;
            } else {
              wasteStreamComputedEntitlement = computedEntitlement;
            }

            // So if multicollection is Per Waste Qty, is a Single Booking, and has Per Waste Collection on
            // And if the Service has Separate Per Waste Stream enabled
            if (!isFake) {
              // --- Get Computed Entitlement from the APIs
              service.wasteStreams.push({
                wasteStreamId,
                wasteVariationId,
                woiWasteTypeId,
                woiWasteItemTypeId,
                wasteComboId,
                name,
                isWasteStream,
                isWasteVariation,
                isWoiWasteType,
                isWoiWasteItemType,
                isSubmitWith,
                isSubmitDefault,
                qty,
                cost,
                computedEntitlement: wasteStreamComputedEntitlement,
                fakeStream
              });
            }
          }
        });

        if (!service.name) {
          service.name =
            serviceSettingsObject[service_setting_id] && serviceSettingsObject[service_setting_id][0].service_name;
        }

        arrServices.push(service);
      });

      workOrderObj.services = arrServices;

      return workOrderObj;
    },
    saveState: function () {
      var stateManager = new BookingStateManager();
      stateManager.saveBookingState();
    },
    bypassNavigationCheck() {
      this.allowNavigation = true;
    },
    checkBeforeReload(event) {
      this.removeAddressToList(this.$store.getters.GET_BOOKING_HISTORY_ADDRESS);
      if (
        !this.allowNavigation &&
        this.bookingState &&
        this.bookingState.selectedServiceGroup
      ) {
        event.preventDefault();
        event.returnValue = "";
      }
    },
    nextBtn() {      
      if (this.getIndexStep === 0) {
        const capExceedsError = this.qtyCapExceeds();
        // validate step 1 forms
        if (!this.bookingState.selectedServiceGroup) {
          this.$refs.alertModal.show(
            Texts.render(`BOOKING_FORM_DETAILS_VALIDATION_SERVICE_GROUP`)
          );
          return;
        } else if (!this.bookingState.selectedService) {
          this.$refs.alertModal.show(
            Texts.render(`BOOKING_FORM_DETAILS_VALIDATION_SERVICE`)
          );
          return;
        } else if (
          !this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED &&
          this.bookingState.selectedBookingProducts &&
          (this.bookingState.selectedBookingProducts.length == 0 ||
            this.bookingState.selectedBookingProducts.find(
              (f) => f.invalid != undefined
            ))
        ) {
          this.$refs.alertModal.show(
            this.TEXTS.render(
              `SERVICE_SWITCH_VALIDATION_INCOMPLETE`,
              null,
              { yourItem: `waste type` }
            )
          );
          return;
        } else if (
          this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED &&
          this.$store.getters
            .GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS.length === 0
        ) {
          this.$refs.alertModal.show(
            this.TEXTS.render(
              `SERVICE_SWITCH_VALIDATION_INCOMPLETE`,
              null,
              { yourItem: `waste type` }
            )
          );
          return;
        } else if (
          this.$refs.productSelection &&
          this.$refs.bookingSummary.sectionThreeHasError
        ) {
          this.$refs.alertModal.show(
            Texts.render(`BOOKING_SUMMARY_COLLECTIONS_ERROR_NOHTML`)
          );
          return;
        } else if (
          this.$refs.collectionWeek.dateFilter &&
          this.$refs.collectionWeek.dateFilter.availableEntitledDates.length ==
            0
        ) {
          if (!this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) {
            if (
              this.bookingState.selectedBookingProducts.some(
                (prod) => prod.hasVariation
              )
            ) {
              this.$refs.alertModal.show(
                this.TEXTS.render(
                  `SERVICE_SWITCH_VALIDATION_INCOMPLETE`,
                  null,
                  { yourItem: `waste type` }
                )
              );
              return;
            }
              //BAUM-4911 - Update no available date pop up 
              if(Helper.getPortalName() == "cityofpae"){
                this.$refs.alertModal.show(
                  Texts.render(`BOOKING_FORM_DETAILS_VALIDATION_NO_DATES_AVAILABLE_FOR_CITYOFPAE`)
                );
              }else{
                this.$refs.alertModal.show(
                  Texts.render(`BOOKING_FORM_DETAILS_VALIDATION_NO_DATES_AVAILABLE`)
                );
              }
            return;
          }

          if (!this.validateBeforeAddNewProductService()) {
            return;
          }
        } else if (
          !this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED &&
          (!this.bookingState.collectionData ||
            !this.bookingState.collectionData.selectedPeriod)
        ) {
          this.$refs.alertModal.show(
            Texts.render(`BOOKING_FORM_DETAILS_VALIDATION_NO_DATE_SELECTED`)
          );
          return;
        } else if (
          this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED &&
          !(
            this.multipleServiceSelectedBooking ||
            new MultipleServiceSelectedBooking()
          ).countedBookedServicesEqualsDates(
            this.$store.getters
              .GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS,
            this.$store.getters
              .GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_DATES
          )
        ) {
          this.$refs.alertModal.show(
            Texts.render(`SERVICE_SWITCH_VALIDATION_INCOMPLETE`, null, {
              yourItem: `collection date`,
            })
          );
          return;
        } else if (
          Helper.getPortalName() === "bayswater" &&
          this.productHasOtherSelected &&
          (!this.bookingState.comment ||
            (this.bookingState.comment && !this.bookingState.comment.trim()))
        ) {
          this.$refs.alertModal.show(
            Texts.render(`BOOKING_FORM_DETAILS_NO_COMMENT`)
          );
          return;
        } else if (capExceedsError) {
          this.$refs.alertModal.show(capExceedsError);
          return;
        }
        if(this.bookingState.selectedBookingProducts.some(bookingProduct => bookingProduct.qty == -1)){
          this.$refs.alertModal.show(
                this.TEXTS.render(
                  `SERVICE_SWITCH_VALIDATION_INCOMPLETE`,
                  null,
                  { yourItem: `waste type` }
                )
              );
              return;
        }

        this.$store.dispatch("setBookingState", { acceptedTerms: false, acceptedTerms2: false, acceptedTerms3: false });
        this.modifyActivePageIndex();
      } else if (this.getIndexStep === 1) {
        // Page 2
        //Check Validations
        let isValid = this.$refs.personalInfo.validate();
        if (!isValid) {
          // Check the Terms and Conditions as well
          return;
        }

        // Personal Info Page - Paid
        if (
          (!this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED &&
            this.bookingState.selectedService.is_paid == Helper.Payment.Paid) ||
          (this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED &&
            this.HAS_PAID_PRODUCTS)
        ) {
          this.$store.dispatch("setBookingState", { acceptedTerms: false, acceptedTerms2: false, acceptedTerms3: false });
          if (this.$refs.paymentSection) {
            /**
            * Ticket:   RP-170
            * Date:     2021-05-19
            * Author:   Joseph Ricohermoso
            * Desc:     Reset the payment section when moving back end fort from other pages
            */
            this.$refs.paymentSection.resetForm();
            // this.$refs.paymentSection.acceptedTerms = false;
          }
          this.modifyActivePageIndex();
        }
        // Personal Info Page - Free
        if (
          (!this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED &&
            this.bookingState.selectedService.is_paid == Helper.Payment.Free) ||
          (this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED &&
            !this.HAS_PAID_PRODUCTS)
        ) {
          if (!this.termShouldValidate()) {
            return;
          }

          // currently in free collection - personal info page
          const form = this.generateWorkOrderBody();
          this.$store.dispatch("setSubmission", { loading: true, form, error: '' });
          this.$store.dispatch("submitWorkOrderForm");
        }
      } else if (this.getIndexStep === 2) {
        // Step 1: Validate Payment Form
        if (!this.$refs.paymentSection) return;

        this.$refs.paymentSection.validateAll(true);
        var paymentValidations = this.$refs.paymentSection.validations;
        if (!paymentValidations || !paymentValidations.valid) {
          return;
        }

        // Step 2: Check T&C checkbow
        if (!this.termShouldValidate()) return;

        // Step 3: Submit Form
        const form = this.generateWorkOrderBody();
        this.$store.dispatch("setSubmission", { loading: true, form, error: '' });
        if (this.$store.getters.GET_PAYMENT_INFO.valid) {
          this.$store.dispatch("workOrderCheck", "submitPayment");
        }
      }
    },
    termShouldValidate() {
      if (
        this.bookingState.hasEndTerms === "yes" &&
        this.bookingState.isAgreedToTerms === "yes" &&
        (
          (this.bookingState.endTermsContent &&
              this.bookingState.endTermsContent !== '' &&
              !this.bookingState.acceptedTerms) ||
          (this.bookingState.endTermsContent2 &&
              this.bookingState.endTermsContent2 !== '' &&
              !this.bookingState.acceptedTerms2) ||
          (this.bookingState.endTermsContent3 &&
              this.bookingState.endTermsContent3 !== '' &&
              !this.bookingState.acceptedTerms3)
        )
      ) {
        alert("Please accept the terms and conditions");
        return false;
      }
      return true;
    },
    prevBtn() {
      // this.scrollToTop();
      return this.$store.dispatch("activeFormIndex", --this.activeStepIndex);
    },
    modifyActivePageIndex() {
      this.$store.dispatch("setBookingState", { onlyUsedEntitlementCount: 0 });
      this.$store.dispatch("setActiveMultipleServiceOtherBookingState", {
        onlyUsedEntitlementCount: 0,
      });
      // this.scrollToTop();
      this.focusOnSectionAfter("nextSection");

      // First Page
      if (this.activeStepIndex == 0) {
        const arrBookingState = !this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED
          ? [
              [
                this.bookingState.selectedServiceGroup.service_group_id,
                [this.bookingState],
              ],
            ]
          : Object.entries(
              Helper.objectsGroupBy(
                this.$store.getters
                  .GET_ACTIVE_MULTIPLE_SERVICE_OTHER_BOOKING_STATE,
                "service_group_id"
              )
            );

        let self = this;
        let forBreak = false;
        let errorEntitlement = false;
        let errorMultipleCollection = false;
        var greatestMaxRatio = 0;
        var entitlementsOfService = 0;
        for (var i = arrBookingState.length - 1; i >= 0; i--) {
          const service_group_id = arrBookingState[i][0];

          // `services` holds an object. Pattern: { service_setting_id : [selectedBookingProducts] }
          // Initial setup of services. Single service booking.
          let services = {};

          if (this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) {
            this.multipleServiceSelectedBooking =
              this.multipleServiceSelectedBooking ||
              new MultipleServiceSelectedBooking();
            const serviceGroups = this.multipleServiceSelectedBooking.groupBy(
              "service_group_id",
              this.$store.getters
                .GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS
            );
            let wastesOfServiceGroup = serviceGroups.find(
              (serviceGroup) => serviceGroup[0] == service_group_id
            );
            if (wastesOfServiceGroup && wastesOfServiceGroup[1].length > 0) {
              services = Helper.objectsGroupBy(
                wastesOfServiceGroup[1],
                "service_setting_id"
              );
            }
          } else {
            services[
              this.bookingState.selectedService.service_setting_id
            ] = this.bookingState.selectedBookingProducts;
          }

          for (let service_setting_id in services) {
            const selectedProducts = services[service_setting_id];
            const theSelectedService = this.$store.getters.GET_SERVICES.list.find(
              (s) => s.service_setting_id == service_setting_id
            );

            var maxCollection = arrBookingState[i].multipleCollectionCount
              ? arrBookingState[i].multipleCollectionCount
              : 0;
            var selectedServiceSummary = new SelectedWasteSummary(
              selectedProducts
            );
            var displayMultipleCollection =
              arrBookingState[i].displayMultipleCollection;
            var displayStreamQuantities =
              arrBookingState[i].displayStreamQuantities;

            // --- If Multiple Entitled Collection is Enabled (the dropdown thing)
            if (
              this.$refs.displayMultipleCollection == true &&
              maxCollection > 1
            ) {
              // GreatestMaxRatio doesn't use entire maxCollection
              greatestMaxRatio = selectedServiceSummary.calculateGreatestMaxRatio(); // Round this up
              if (maxCollection > greatestMaxRatio) {
                this.$store.dispatch("setBookingState", {
                  onlyUsedEntitlementCount: greatestMaxRatio,
                });
                this.$store.dispatch(
                  "setActiveMultipleServiceOtherBookingState",
                  { onlyUsedEntitlementCount: greatestMaxRatio }
                );
                errorEntitlement = true;
                forBreak = true;
                break;
              }
            } else if (
              !displayMultipleCollection &&
              displayStreamQuantities &&
              theSelectedService.multi_collection_popup == "1"
            ) {
              // Multi Collection is available
              var selectedServiceId = theSelectedService.entitlement_setting_id;
              var entitlementSummary = arrBookingState[i].entitlementSummary;
              entitlementsOfService =
                entitlementSummary.effectiveEntitlements[selectedServiceId];
              if (
                entitlementsOfService &&
                !isNaN(entitlementsOfService) &&
                entitlementsOfService >= 999
              ) {
                entitlementsOfService = "Unlimited";
              }
              greatestMaxRatio = selectedServiceSummary.calculateGreatestMaxRatio(); // Round this up
              errorMultipleCollection = true;
              forBreak = true;
              break;
            }
          } // End Inner for

          if (forBreak) {
            break;
          }
        } // End Outer For

        if (errorEntitlement) {
          this.$emit(
            "showFreeEntitlements",
            Texts.render(`BOOKING_FORM_DETAILS_SHOW_FREE_ENTITLEMENTS`, null, {
              greatestMaxRatio: greatestMaxRatio,
            }),
            function () {
              return this.$store.dispatch(
                "activeFormIndex",
                ++self.activeStepIndex
              );
              setTimeout(next, 100);
            }
          );
          return;
        }

        if (errorMultipleCollection) {
          this.$emit(
            "showFreeEntitlements",
            Texts.render(
              `BOOKING_FORM_DETAILS_MULTIPLE_COLLECTION_NOTICE`,
              null,
              {
                toBeConsumed: greatestMaxRatio,
                totalEntitlements: entitlementsOfService,
              }
            ),
            function () {
              return this.$store.dispatch(
                "activeFormIndex",
                ++self.activeStepIndex
              );
              setTimeout(next, 100);
            }
          );
          return;
        }

        return this.$store.dispatch("activeFormIndex", ++this.activeStepIndex);
      } else if (
        this.activeStepIndex == 1 &&
        ((!this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED &&
          this.bookingState.selectedService.is_paid == Helper.Payment.Free) ||
          (this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED &&
            !this.HAS_PAID_PRODUCTS))
      ) {
        return this.$store.dispatch(
          "activeFormIndex",
          this.activeStepIndex + 2
        );
      } else {
        return this.$store.dispatch("activeFormIndex", ++this.activeStepIndex);
      }
    },
    showModalIfError(error, statusCode, type) {
      if (error || statusCode) {
        this.$emit("showPaymentResult", type, false, error, statusCode);
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    focusOnSectionAfter(clearedSection) {
      var scrollToAnchor;
      if (clearedSection == "selectServiceButton") {
        scrollToAnchor = "termsAndConditionsAnchor";
      } else if (clearedSection == "termsAndConditions") {
        scrollToAnchor = "termsAndConditionsAnchor";
      } else if (clearedSection == "selectPaymentButton") {
        scrollToAnchor = "wasteAnchor";
      } else if (clearedSection == "nextSection") {
        scrollToAnchor = "progressBarAnchor";
      }
      if (
        (scrollToAnchor && Helper.isUserMobile()) ||
        (scrollToAnchor == "progressBarAnchor" && !Helper.isUserMobile())
      ) {
        // --- Adding a delay to allow the HTML to draw first
        setTimeout(() => {
          Helper.scrollIntoView(scrollToAnchor);
        }, 200);
      }
    },
    removeLoader() {
      this.fetchLoadingClasses.pop();
    },
    setMultipleCollection(multipleCollection) {
      this.$refs.productSelection.setMultipleCollection(multipleCollection);
    },
    serviceAlert(message) {
      this.$refs.alertModal.show(message);
      return;
    },
    serviceGroupConfirm(targetService) {
      let self = this;

      /*
                    Stry: [Adjustment]_007_S15_: do not show pop up to clear previous request for CSO
                    Date: 2021-02-03
                    Auth: Franco Mapua
                */
      var userType = this.userType;
      var checkErrorInSummarySecThree = this.bookingState.hasErrorInSummarySecThree;


      if (userType.indexOf("cso") > -1) {
        if (checkErrorInSummarySecThree) {
          this.$refs.alertModal.show(
              Texts.render(`BOOKING_SUMMARY_COLLECTIONS_ERROR_NOHTML`)
            );
          return;
        }else{
          self.$emit("forceSelectServiceGroup", targetService);
        }

      } else {
        
        if (checkErrorInSummarySecThree) {
          this.$refs.alertModal.show(
              Texts.render(`BOOKING_SUMMARY_COLLECTIONS_ERROR_NOHTML`)
            );
          return;
        }else{
          this.$emit(
            "confirmClearingServiceGroup",
            Texts.render(`SERVICE_GROUP_SWITCH_CLEAR_CONFIRM`),
            function () {
              // If confirmed. Clear the products under this service group
              self.$store.dispatch(
                "clearActiveMultipleServiceGroupSelectedBooking"
              );
              self.$emit("forceSelectServiceGroup", targetService);
            },
            function () {
              self.$emit("forceSelectServiceGroup", targetService);
            }
          );
        }
        
      }
    },
    validateBeforeAddNewProductService() {
      let message = null;
      if (
        this.$store.getters
          .GET_HAS_PARENT_WASTES_SELECTED_AND_EMPTY_CURRENT_SERVICE_WASTES ||
        this.$store.getters.GET_HAS_PARENT_WASTES_SELECTED
      ) {
        message = this.TEXTS.render(
          `SERVICE_SWITCH_VALIDATION_INCOMPLETE`,
          null,
          { yourItem: `waste type` }
        );
      } else if (
        this.$store.getters
          .GET_HAS_CURRENT_SERVICE_WASTES_AND_EMPTY_CURRENT_SERVICE_DATES
      ) {
        message = this.TEXTS.render(
          `SERVICE_SWITCH_VALIDATION_INCOMPLETE`,
          null,
          { yourItem: `collection date` }
        );
      }

      if (message) {
        this.$refs.alertModal.show(message);
        return false;
      }
      return true;
    },
    addNewProductService(allow) {
      var isLvl1StreamEmpty = this.bookingState.selectedBookingProducts.some(
        (prod) => prod.multiSpinnerChecker
      );

      var checkErrorInSummarySecThree = this.bookingState.hasErrorInSummarySecThree;

      if (isLvl1StreamEmpty) {
        
        this.$refs.alertModal.show(
          this.TEXTS.render(`SERVICE_SWITCH_VALIDATION_INCOMPLETE`, null, {
            yourItem: `waste type`,
          })
        );
        return;
      }

      if (checkErrorInSummarySecThree) {
        
        this.$refs.alertModal.show(
            Texts.render(`BOOKING_SUMMARY_COLLECTIONS_ERROR_NOHTML`)
          );
        return;
      }

      this.easySwitchToServiceGroup = allow;
      if (allow) {
        // this.scrollToTop();
        this.focusOnSectionAfter("nextSection");
      }
    },
    showConfirmClearGroup(param) {
      let self = this;
      this.$emit(
        "confirmClearingServiceGroup",
        Texts.render(`SERVICE_AND_GROUP_QUICK_CLEAR_CONFIRM`),
        function () {
          self.$store.dispatch(
            "clearActiveMultipleServiceGroupSelectedBookingByService",
            param
          );
        }
      );
      return;
    },
    setAvailableEntitledDatesLength(length) {
      this.availableEntitledDatesLength = length;
    },
    alertFailedEmailNotif() {
      /**
       * Task:    BAUM-978
       * Author:  Joseph Ricohermoso
       * Date:    2021-08-18
       * Desc:    Should show an info message after successful booking but failed in email notif stage
       * */
      const ERR = 'ERROR_WO_EMAIL_NOTIF_FAILURE';
      if (this.$store.getters.GET_BOOKING_COMPLETED_DETAILS &&
          this.$store.getters.GET_BOOKING_COMPLETED_DETAILS.message &&
          this.$store.getters.GET_BOOKING_COMPLETED_DETAILS.message.includes(ERR) ) {
        Toastify({
            text: this.TEXTS.render(ERR),
            duration: 8000,
            gravity: "bottom",
            position: 'right', 
            offset: {
                x: '2rem',
                y: '2rem'
            },
            style: {
              color: 'initial',
              background: '#FFCC00'
            },
            onClick: function(){}
          }).showToast();
      }
    },
    backToHome() {
      this.$router.push('/booking/home');
    }
  },
  watch: {
    // formSubmitted: function (success) {
    //   if (success) {
    //     var self = this;
    //     self.allowNavigation = true;
    //     if (
    //       (!this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED &&
    //         this.bookingState.selectedService.is_paid == Helper.Payment.Paid) ||
    //       (this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED &&
    //         this.HAS_PAID_PRODUCTS)
    //     ) {
    //       this.$emit(
    //         "showPaymentResult",
    //         "payment",
    //         true,
    //         null,
    //         null,
    //         function () {
    //           self.modifyActivePageIndex();
    //           self.alertFailedEmailNotif();
    //         }
    //       );
    //     } else {
    //       self.modifyActivePageIndex();
    //       self.alertFailedEmailNotif();
    //     }
    //   }
    // },
    bookingSubmission: function (val) {
      // If still loading
      if (val.loading) {
        return;
      }

      // If booking form was submitted
      if(val.submitted) {
        var self = this;
        self.allowNavigation = true;
        // If service allow queue and user is not CSO
        if(this.bookingSubmission.form.isQueueBooking && this.userType != 'cso') {
          this.$emit(
            "showPaymentResult",
            "queue",
            true,
            this.bookingSubmission.form.queueBookingMessage,
            200,
            async () => {
              // Reset Booking State and go to history page
              const addressId = self.bookingState.activeAddress.id;
              // Remove active address before reset booking state
              if (self.activeAddress && self.activeAddress.displayName) {
                self.removeAddressToList(self.activeAddress.displayName.toLowerCase());
              }
              await self.$store.dispatch("resetBookingState");
              $('#pageLoadingModal').modal('hide');
              if(self.$refs.alertModal) {
                self.$refs.alertModal.hide();
              }
              self.$router.push({ path: 'history', query: { id: addressId }});
            }
          );
          return;
        } else if (
          (!this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED &&
            this.bookingState.selectedService.is_paid == Helper.Payment.Paid) ||
          (this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED &&
            this.HAS_PAID_PRODUCTS)
        ) {
          this.$emit(
            "showPaymentResult",
            "payment",
            true,
            null,
            null,
            function () {
              self.modifyActivePageIndex();
              self.alertFailedEmailNotif();
            }
          );
        } else {
          self.modifyActivePageIndex();
          self.alertFailedEmailNotif();
        }
      }

      this.showModalIfError(null, val.statusCode, "booking");
    },
    paymentInfo: function (val) {
      this.showModalIfError(val.error, null, "payment");
    },
    activeAddressSetting: function (newVal, oldVal) {
      if (newVal) {
        // set to state
        var bookingState = this.bookingState;
        bookingState.activeAddressSetting = newVal;
        this.$store.dispatch("setBookingState", bookingState);
      }
    },
  }
};
</script>